import { writable } from "svelte/store";

const { subscribe, set, update } = writable({ type : null });

export const activeQuote = {
    subscribe,
    setActiveQuote : (quote) => {
        update((store) => ({ ...quote }));
    },
    clear : () => set({ type : null })
};
